import React, { useState } from 'react';
import { resolveBackendUrl } from '../utils/backendUrl';

export default function UserAvatar({ profile, size = 32, style = {} }) {
  const backendUrl = resolveBackendUrl();
  const [failed, setFailed] = useState(false);

  const raw = profile?.profile_picture_url || '';
  const url = raw
    ? (String(raw).startsWith('http') ? raw : `${backendUrl}${raw}`)
    : '';
  const hasAvatar = !!url && !failed;

  if (hasAvatar) {
    return (
      <img
        src={url}
        alt="Profile"
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, ...style }}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', flexShrink: 0,
      background: 'linear-gradient(135deg, #5A38FD, #7F00FF)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: Math.round(size * 0.4), fontWeight: 700, color: '#fff',
      ...style,
    }}>
      {profile?.first_name?.[0] || '?'}
    </div>
  );
}
